















































import Vue from 'vue';
import axios from 'axios';
import api from '../api';
import {AxiosRequestConfig} from 'axios';
import {Form} from 'element-ui';
import csrftoken from '../getToken';
import gql from 'graphql-tag';
export default Vue.extend({
  data() {
    const that = this;
    const validatePass = (rule: string, value: string, callback: (this: void, e: object | undefined) => void ) => {
        let reg = /^(?![a-zA-Z]{1,15}$)(?![0-9]{1,15}$)[a-zA-Z0-9]{6,16}$/;
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!!value && value.length >= 6 && value.length <= 16) {
            const reg1 = /\d/;
            const reg2 = /[a-zA-Z]/;
            if (!reg1.test(value) || !reg2.test(value)) {
              callback(new Error('需包含至少一个字母和一个数字'));
            } else {
              callback(undefined);
            }
        }
      };
    const validatePass2 = (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !==  (that as any).resetPassForm.new_password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback(undefined);
          }
      };
    const checkPhoneNumber = async (rule: string,value: string,callback: (this: void,e: object | undefined) => void) => {
      let self = this;
      if(typeof(value) !== "string") {
        callback(new Error('请输入字符串数据'));
      } else {
        if(value === '') {
          callback(new Error('请输入电话号码'));
        } else {
          if(!(/^1\d{10}$/.test(value))) {
            callback(new Error('电话号码格式不正确'));
          } else {
            let validRes = await this.$apollo.query({
              query: gql`{
                unoccupied(field:phone,value:"${value}")
              }`,
              fetchPolicy: "no-cache"
            })
            // console.log("validRes is ",validRes);
            if(!validRes.data.unoccupied) {
              // 该手机号被注册过可以找回密码
              callback(undefined);
            } else {
              // 该手机号没有被注册不能找回密码
              callback(new Error('请输入之前注册的号码'));
            }
          }
        }
      }
    };
    return {
      btnText: '获取验证码',
      disabled: false,
      timer: 0,
      typeText: 'primary',
      // 用户是否存在
      userExist: true,
      resetPassForm: {
        phone: '',
        vcode: '',
        new_password: '',
        checkPass: '',
      },
      rules: {
        phone:[
          { required: true,validator: checkPhoneNumber,trigger: 'blur'}
        ],
        new_password: [
          { min: 6, max: 15, message: '长度在 6 到 16 个字符', trigger: 'blur' },
          { require: true,validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [
          { require: true,validator: validatePass2, trigger: 'blur' },
        ],
        vcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    async getCode() {
        this.disabled = true;
        let num = 60;
        let self = this;
        this.timer = window.setInterval(() => {
            num--;
            this.btnText = `${(num)}s后重新发送`;
            if (num <= 0) {
                clearInterval(self.timer);
                self.btnText = '获取验证码';
                self.disabled = false;
                self.typeText = 'primary';
            }
        }, 1000);
        let phone = this.resetPassForm.phone;
        let codeRes = await this.$apollo.mutate({
          mutation: gql`mutation {
            sendVCode(phone: "${phone}")
          }`
        })
    },
    async resetPassword(formName: string) {
      (this.$refs[formName] as Form).validate(async (valid: boolean) => {
        if (valid) {
          const params = {
            password: this.resetPassForm.new_password,
            vcode: this.resetPassForm.vcode,
          };
          let phone = this.resetPassForm.phone;
          try {
            let resetPasswordRes = await this.$apollo.mutate({
                    // Query
                    mutation: gql`mutation{
                        doctorResetPassword(phone: "${phone}",
                                            vcode: "${params.vcode}",
                                            password: "${params.password}"
                                          )
                      }`,
                    fetchPolicy:"no-cache"
                  })
            this.$message({
              message: "重置成功",
              type: "success"
            })
            this.$refs.resetPassForm.resetFields();
            this.$emit('closeResetPassWin');
          } catch(error) {
            this.$message.error(error.message.split(":")[1]);

          }
        } else {
          return false;
        }
      });
    },
    operateFaileTip(msg: string) {
        const h: (a: string, b: object, c: string) => any = this.$createElement;
        this.$notify({
          title: '重置密码失败',
          message: h('i', { style: 'color: teal'}, msg),
        });
      },
    resetForm(formName: string) {
      (this.$refs[formName] as Form).resetFields();
    },
    blur(event: Event) {
      alert(this.resetPassForm.checkPass);
    },
  },
});
